import type { CSSProperties, ReactNode } from 'react';
import '../../../atomic/layout/app_screen/app_screen.css';
import { containFitScale } from '../../../../../../infrastructure/runtime';
import { useAppFit } from '../../../../../hooks/useAppFit';
import { DialogPopup } from '../../../atomic/dialog/dialog_popup/DialogPopup';
import { PagePaginator } from '../../../atomic/buttons/page_paginator/PagePaginator';
import { SkyAtmosphere } from '../../atmosphere/sky_atmosphere/SkyAtmosphere';
import './WelcomeShell.css';

export type WelcomeShellProps = {
  className: string;
  paginatorCurrent: number;
  /** Between atmosphere and DialogPopup (e.g. welcome_1 Character). */
  beforeDialog?: ReactNode;
  /** After DialogPopup, before paginator (texts, decor, character). */
  afterDialog?: ReactNode;
  button: ReactNode;
};

/** Shared welcome sky + dialog popup + paginator with content slots. */
export function WelcomeShell({
  className,
  paginatorCurrent,
  beforeDialog,
  afterDialog,
  button,
}: WelcomeShellProps) {
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <div className={['app-screen', className].filter(Boolean).join(' ')}>
      <SkyAtmosphere variant="welcome" />
      <div
        className="welcome-shell-plaques"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        {beforeDialog}
        <DialogPopup />
        {afterDialog}
        <PagePaginator current={paginatorCurrent} />
        {button}
      </div>
    </div>
  );
}
